module.exports = __webpack_public_path__ + "assets/img/11.d617f1dc.png";